import { render, staticRenderFns } from "./UserMescanMetabolismLung.vue?vue&type=template&id=1aec8ea2&scoped=true"
import script from "./UserMescanMetabolismLung.vue?vue&type=script&lang=js"
export * from "./UserMescanMetabolismLung.vue?vue&type=script&lang=js"
import style0 from "./UserMescanMetabolismLung.vue?vue&type=style&index=0&id=1aec8ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec8ea2",
  null
  
)

export default component.exports